import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getAdminLoginRoles } from '../Constant.js'
import axios from 'axios'

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    role: 'super-admin',
    cred: [],
    countryList: [],
    remember: false,
    country_name: 'KWT',
  }

  componentDidMount() {
    try {
      let userData = localStorage.getItem('user_login_details')
      userData = JSON.parse(userData)

      if (userData?.email && userData?.password && userData?.country_name && userData?.role) {
        this.setState({
          email: userData.email,
          password: userData.password,
          country_name: userData.country_name,
          role: userData.role,
          remember: true,
        })
      }
    } catch (err) {
      // TODO:
    }

    this.countryList()
  }

  countryList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/auth/list-countries?show_all_countries=true')
      .then((res) => {
        if (res.data.success) {
          that.setState({
            countryList: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSelectChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onLogin = async (event) => {
    event.preventDefault()

    var role = this.state.role
    var country = this.state.role == 'wego-admin' ? 'KWT' : this.state.country_name

    if (!this.state.country_name) {
      Swal.fire({
        title: 'Please Select the country',
        icon: 'error',
        text: '',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return
    }

    this.setState({ isSaving: true })

    // Remember me logic
    if (this.state.remember) {
      localStorage.setItem(
        'user_login_details',
        JSON.stringify({
          email: this.state.email,
          password: this.state.password,
          country_name: this.state.country_name,
          role: this.state.role,
        })
      )
    } else {
      localStorage.removeItem('user_login_details')
    }
    // -------------------

    await axios
      .post(Constant.getAPI() + `/auth/sign-in`, {
        email: this.state.email,
        password: this.state.password,
        country_short_name: this.state.country_name,
        role: this.state.role,
      })
      .then((response) => {
        if (response.data.success === true) {
          localStorage.setItem('countryShortName', this.state.country_name)

          let adminRoles = [
            'super-admin',
            'ops-coord',
            'sr-ops-coord',
            'ops-sup',
            'ops-mgr',
            'mkt-mgr',
            'mkt-coord',
            'sales-mgr',
            'sales-member',
            'finance-mgr',
            'finance-member',
            'owners',
          ]
          let isSuperAdmin = adminRoles.includes(response.data.data.result.user_type)

          if (
            response.data.data.result.user_type === role &&
            (response.data.data.result.country === country || isSuperAdmin)
          ) {
            localStorage.setItem('loged_In', true)
            localStorage.setItem('loged_In_auth', response.data.data.token)
            localStorage.setItem('ad_name', response.data.data.result.first_name)
            localStorage.setItem('loged_In_role', isSuperAdmin ? 'super-admin' : role)
            localStorage.setItem('user_role', role)
            localStorage.setItem('ad_email', response.data.data.result.email)

            Swal.fire({
              title: 'Login Successfully',
              icon: 'success',
              text: '',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })

            window.location.reload()
          } else {
            Swal.fire({
              title: 'Incorrect Credentials',
              icon: 'error',
              text: '',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        } else {
          Swal.fire({
            title: response.data.message || 'Incorrect Credentials',
            icon: 'error',
            text: '',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch(() => {
        Swal.fire({
          title: 'Please check credentials',
          icon: 'error',
          text: '',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
  }

  render() {
    return (
      <section className="login-block">
        <div className="logincontainer">
          <div className="login-image-section"></div>
          <div className="login-section">
            <div className="row">
              <div className="col-12 m-b-20">
                <form className="md-float-material form-material">
                  <div
                    className="auth-box card p-15"
                    style={{ backgroundColor: '#0D547E', boxShadow: '10px 10px 10px 0 rgba(69, 90, 100, 0.7)' }}
                  >
                    <div className="card-block">
                      <div className="text-center m-b-10">
                        <img
                          src="./assets/images/icon2.png"
                          alt="Waves-App"
                          width="150"
                        />
                      </div>
                      <div className="row m-b-20">
                        <div className="col-md-12">
                          <h2
                            className="text-center"
                            style={{ color: '#fff' }}
                          >
                            Welcome to Back Office
                          </h2>
                        </div>
                        <div
                          className="col-md-12"
                          style={{ color: '#ccc' }}
                        >
                          <h6 className="text-center">
                            Tap into data that helps you grow. Check on sales, chart your progress and attract new
                            customers with special offers.
                          </h6>
                        </div>
                      </div>
                      <div className="form-group form-primary">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 'bold', color: '#fff' }}
                        >
                          Country
                        </h6>
                        <select
                          name="country_name"
                          className="form-control"
                          onChange={this.onSelectChange}
                          value={this.state.country_name}
                          style={{ borderRadius: 10 }}
                        >
                          {this.state?.countryList?.length > 0 &&
                            this.state.countryList?.map((itm, i) => (
                              <option
                                value={itm?.country_short_name}
                                key={i}
                              >
                                {itm?.country_name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group form-primary">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 'bold', color: '#fff' }}
                        >
                          User Type
                        </h6>
                        <select
                          name="role"
                          className="form-control"
                          onChange={this.onSelectChange}
                          value={this.state.role}
                          style={{ borderRadius: 10 }}
                        >
                          {getAdminLoginRoles().map((itm) => (
                            <option
                              value={itm.value}
                              key={itm.value}
                            >
                              {itm.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group form-primary">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 'bold', color: '#fff' }}
                        >
                          Email
                        </h6>
                        <input
                          type="text"
                          name="email"
                          className="form-control"
                          required=""
                          placeholder="UserName"
                          onChange={this.onInputChange}
                          value={this.state.email}
                          style={{ borderRadius: 10 }}
                        />
                      </div>
                      <div className="form-group form-primary">
                        <h6
                          className="text-left"
                          style={{ fontWeight: 'bold', color: '#fff' }}
                        >
                          Password
                        </h6>
                        <input
                          type="password"
                          name="password"
                          className="form-control"
                          required=""
                          placeholder="Password"
                          value={this.state.password}
                          onChange={this.onInputChange}
                          style={{ borderRadius: 10 }}
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <label style={{ display: 'flex', marginBottom: 0 }}>
                            <input
                              style={{ marginRight: 10 }}
                              type="checkbox"
                              checked={this.state.remember}
                              onChange={() => {
                                this.setState({
                                  remember: !this.state.remember,
                                })
                              }}
                            />
                            <span style={{ color: '#fff', fontWeight: 'bold' }}>{'Remember Me'}</span>
                          </label>
                        </div>
                      </div>
                      <div className="row m-t-10">
                        <div className="col-md-12">
                          <button
                            type="button"
                            onClick={this.onLogin}
                            style={{ borderRadius: 10, fontWeight: 'bold' }}
                            className="btn btn-primary btn-md btn-block waves-effect"
                          >
                            Log In
                          </button>
                        </div>
                      </div>
                      {/* <div className="col-md-12 m-t-10">
                        <h6 className="text-center text-white" style={{ fontWeight: 'bold' }}>Forgot Password?</h6>
                      </div> */}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Login
